import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { TemplateComponent } from "./template/template.component";
import { Error404Component } from "./error404/error404.component";
import { LoginComponent } from "./login/login.component";
import { DeletedComponent } from "./deleted/deleted.component";
import { LogoutComponent } from "./logout/logout.component";
import { LibrarySelectorComponent } from "./library-selector/library-selector.component";
import { PasswordResetComponent } from "./password-reset/password-reset.component";
import { LibrarySelectedGuard } from "../guards/library-selected.guard";
import { ExecutePasswordResetComponent } from "./password-reset/execute-password-reset/execute-password-reset.component";
import { AutoLibrarySelectionComponent } from "./auto-library-selection/auto-library-selection.component";
import { PasswordUpdateComponent } from "./password-update/password-update.component";

const routes: Routes = [
  {
    path: "logout",
    component: LogoutComponent,
  },
  {
    path: "",
    component: TemplateComponent,
    children: [
      { path: "", component: LibrarySelectorComponent },
      {
        path: "login",
        component: LoginComponent,
        canActivate: [LibrarySelectedGuard],
      },
      {
        path: "select-library/:label",
        component: AutoLibrarySelectionComponent,
      },
      {
        path: "password",
        component: PasswordResetComponent,
        canActivate: [LibrarySelectedGuard],
      },
      {
        path: "update",
        component: PasswordUpdateComponent,
        canActivate: [LibrarySelectedGuard],
      },
      {
        path: "deleted",
        component: DeletedComponent,
        canActivate: [LibrarySelectedGuard],
      },
      {
        path: "reset/:key",
        component: ExecutePasswordResetComponent,
        canActivate: [LibrarySelectedGuard],
      },
    ],
  },
  { path: "**", component: Error404Component },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
